import { render, staticRenderFns } from "./raw_detail.vue?vue&type=template&id=01e8c40f&scoped=true&"
import script from "./raw_detail.vue?vue&type=script&lang=js&"
export * from "./raw_detail.vue?vue&type=script&lang=js&"
import style0 from "./raw_detail.vue?vue&type=style&index=0&id=01e8c40f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8c40f",
  null
  
)

export default component.exports